import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, KeyVal, Page, Radio } from 'equasion-lib';
import ZoneSelectWithScan from '@/lib/shared-coms/ZoneSelectWithScan';
import ActionTopBar from '@/lib/shared-coms/ActionTopBar';
import { Formik, Form } from 'formik';
import { FiCheckCircle } from 'react-icons/fi';
import { quarantineValidation } from './Quarantine.validation';
import './Quarantine.scss';

const Quarantine = ({
  serializedItemState,
  bulkInventoryEventCreate,
  selectedCompanyId
}) => {
  const navigate = useNavigate();
  const [quarantined, setQuarantined] = useState(false);
  const { purchaseOrder, pedigree, serialNumber, gtin } = serializedItemState || {};
  const { id: purchaseOrderId, clientPurchaseOrderNumber } = purchaseOrder || {};
  const { ITEM } = pedigree || {};

  const submitBulkInventoryEventCreate = async (values, actions) => {
    const { setSubmitting } = actions;
    try {
      const { zoneId } = values;
      await bulkInventoryEventCreate({
        variables: {
          serialNumber,
          gtin,
          companyId: selectedCompanyId,
          inventoryEventAttributes: {
            type: 'QUARANTINE',
            zoneId: zoneId,
            companyId: selectedCompanyId
          }
        }
      });
      setQuarantined(true);
    } catch (e) {
      console.log(`ERROR UPDATING PRODUCTS: ${e}`);
    }
    setSubmitting(false);
  };

  return (
    <Page className="quarantine action-page">
      <ActionTopBar
        action="Quarantine"
        serialNumber={serialNumber}
        gtin={gtin}
        actionColor="var(--y600)"
      />
      <div className="action-page-body">
        <KeyVal
          items={[
            {
              key: 'PO Number',
              value: clientPurchaseOrderNumber
            },
            {
              key: 'Serial',
              value: serialNumber
            }
          ]}
        />
        <Formik
          initialValues={{
            deficientType: 'missing',
            zoneId: ''
          }}
          validationSchema={quarantineValidation()}
          validateOnBlur={false}
          onSubmit={submitBulkInventoryEventCreate}
        >
          {({ isSubmitting }) => (
            <Form className="quarantine-form">
              Select a deficient type:
              <Radio
                name="deficientType"
                options={[
                  ['missing', 'Missing Human Readable'],
                  ['readable', 'Human readable GTIN'],
                  ['damage', 'Physical Damage']
                ]}
              />
              Quarantine zone:
              <ZoneSelectWithScan
                name="zoneId"
                label="Quarantine Zone"
                companyId={selectedCompanyId}
                zoneTypes={['quarantine']}
                scanTitle="Scan the quarantine zone"
                scanHint={`Serial ${serialNumber}. Scan the label on the quarantine zone it is going into.`}
              />
              <Button type="primary" isSubmit fullWidth disabled={isSubmitting}>
                Mark as Quarantined
              </Button>
            </Form>
          )}
        </Formik>
      </div>
      <div className={['result-panel', quarantined && 'open'].filter(Boolean).join(' ')}>
        <div className="result-message">
          <FiCheckCircle style={{ color: 'var(--green)' }} />
          <h1>Quarantined Successfully</h1>
          <p>
            {ITEM} products from PO # {clientPurchaseOrderNumber} have been sent to quarantine
          </p>
        </div>
        <div className="result-actions">
          <Button type="primary" fullWidth onClick={() => navigate('/')}>
            Done
          </Button>
        </div>
      </div>
    </Page>
  );
};

export default Quarantine;
